
import Vue from 'vue'

export default Vue.extend({
  name: 'RequestFilter',
  components: {
  },
  props: {
    list: {
      type: Array,
      default: () => []
    }
  },
  data () {
    return {
      filterAddress: '',
      isShowBlock: false
    }
  },
  watch: {
    list () {
      this.filteredPayments()
    },
    filterAddress () {
      this.filteredPayments()
    }
  },
  mounted () {
    this.filteredPayments()
  },
  methods: {
    filteredPayments (): any {
      let filtered = this.list
      if (this.filterAddress) {
        filtered = this.list.filter((item: any) => {
          return item.personalAccount.houseShortAddress.toLowerCase().includes(this.filterAddress.toLowerCase())
        })
      }
      this.$emit('filteredList', filtered)
    }
  }
})
